module.exports = __webpack_public_path__ + "img/Airbnb-Work-on-the-move-Self-Care-1.a45e7271.jpg";